import { CalendarWeek, ClockHistory, LockFill } from 'react-bootstrap-icons';

import { Space, Typography } from 'antd';

import Progress from '@/components/shared/Progress';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import { useModuleProgress } from '@/hooks/useProgress';
import { enStatus, IModule } from '@/interfaces/course';
import { css, StyledProp, styled } from '@/styled';

const infoMapper: Record<string, string> = {
  [enStatus.EXPIRED]: 'Módulo expirado |',
  [enStatus.NOT_RELEASED]: 'Módulo não lançado |',
  [enStatus.BLOCKED]: 'Módulo bloqueado |',
  [enStatus.NOT_PURCHASED]: 'Módulo bloqueado |'
};

const iconMapper: Record<string, any> = {
  [enStatus.EXPIRED]: <ClockHistory size={24} />,
  [enStatus.BLOCKED]: <LockFill size={24} />,
  [enStatus.NOT_RELEASED]: <CalendarWeek size={24} />,
  [enStatus.NOT_PURCHASED]: <LockFill size={24} />
};

const Header = ({ className, module }: StyledProp & { module: IModule }) => {
  const breakpoints = useBreakpoints();
  const progress = useModuleProgress(module.id);

  if (breakpoints.down('md')) {
    return (
      <Space id={`${module?.id}`} className={className} direction='vertical' size={8}>
        <Typography.Title level={4} ellipsis>
          {module?.title}
        </Typography.Title>
        <Typography.Paragraph ellipsis>
          {infoMapper[module?.status] ?? ''} {module?.lessons.length} aulas
        </Typography.Paragraph>
      </Space>
    );
  }

  return (
    <div className={className} id={`${module?.id}`}>
      <Progress type='circle' percent={progress} strokeWidth={4} format={() => iconMapper[module?.status]} />
      <div className='title'>
        <Typography.Title level={4} ellipsis>
          {module?.title}
        </Typography.Title>
        <Typography.Paragraph ellipsis>
          {infoMapper[module?.status]} {module?.lessons.length} aulas
        </Typography.Paragraph>
      </div>
    </div>
  );
};

export default styled(Header)(
  ({ theme }) => css`
    max-width: 100%;
    display: flex;
    gap: ${theme.space.pxToRem(24)};
    .ant-space-item {
      background-color: ${theme.colorBgBase};
      z-index: 1;
    }

    div.ant-typography {
      color: ${theme.colorTextTertiary};
    }

    .title {
      max-width: calc(100% - 64px);
      flex-direction: column;
      display: flex;
      gap: ${theme.space.pxToRem(8)};
    }

    .ant-progress-text {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    svg {
      color: ${theme.colorTextBase};
    }

    .ant-progress,
    .ant-progress-inner {
      width: 40px !important;
      height: 40px !important;
    }
  `
);
